var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief refreshToken module
 *
 ********************************************************************/
//utils
import * as HttpUtil from "@utils/api/HttpUtil";
import * as CONST from "@utils/Const";
/**
 * @brief AutoLogin 컴포넌트
 * @param
 * @returns react components
 */
export function refreshTokenFn(setRecoilUrl, resetRecoilUserInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        const refreshToken = localStorage.getItem(CONST.STR_REFRESHTOKEN); // to localStorage
        let data = null;
        data = yield HttpUtil.PromiseHttp({
            httpMethod: "POST",
            appPath: `/auth/token?token=${refreshToken}`,
            appQuery: { token: refreshToken },
            userToken: "",
        });
        if (data.codeNum == 200) {
            return data;
        }
        else {
            //토큰이 재생성 실패 시 스토리지 초기화
            sessionStorage.removeItem(CONST.STR_TOKEN);
            sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
            localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
            localStorage.removeItem(CONST.STR_USERID);
            localStorage.removeItem(CONST.STR_USERROLE);
            localStorage.removeItem(CONST.STR_REFRESHTOKEN);
            localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
            resetRecoilUserInfo();
            setRecoilUrl(CONST.URL_MAIN);
            localStorage.setItem("loginintro", CONST.URL_MAIN);
            location.reload();
        }
    });
}
export default refreshTokenFn;
